import { twMerge } from "tailwind-merge";

export const LogoDataStone = (className?: string) => {
  const LogoDataStone = document.createElement("img");

  LogoDataStone.src = "/static/logos/data-stone.svg";
  LogoDataStone.alt = "logo";
  LogoDataStone.className = twMerge("object-contain", className);

  return LogoDataStone;
};
